/* eslint-disable operator-linebreak */
/* eslint-disable indent */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  redirectToPhotoTime,
  redirectToConfirmYourPicture,
  redirectToValidationAccessCode,
} from '../../ducks/Navigate';
import {updateDadosPessoais, updateProps} from '../../ducks/Customer';
import Camera, {FACING_MODES, IMAGE_TYPES} from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import {ParamKeys, RouteKeys, SituacaoKeys} from '../../constants';
import {StringService} from '../../services';
import {detect} from 'detect-browser';
import {ScreenNotificationDefault, Footer} from '../../components';

import {AutoCapturaService} from '../../services';

import LivenessComponent, {iniciarCamera} from './Liveness/LivenessComponent';

import './styles.scss';

const browser = detect();
let firstLoad = true;

const ParceirosLiveness = {
  OITI: 'oiti',
  CREDZ: 'credz',
};

const strPraBool = (valor) => valor === 'True';

// Componente Funcional
const TakeYourPicture = (props) => {
  // #region ESTADOS
  const [state, setState] = useState({
    alturaCamera: 0,
    alturaVideo: 0,
    tamanhoVideo: 0,
    cameraStarted: false,
    cameraAtiva: FACING_MODES.USER,
    cameraEspelhada: true,
    livenessParceiro: '',
  });

  const [livenessSettings, setLivenessSettings] = useState({
    cpf: '',
    nome: '',
    nascimento: '',
    user: '',
    pass: '',
    fcvarUrlbase: '',
    appKey: '',
  });

  const [resultLiveness, setResultLiveness] = useState({
    valid: false,
    codID: 0.0,
    cause: 'CERTIFACE',
    protocol: 0,
    snap: '',
  });

  const [fail, setFail] = useState(false);
  // #endregion

  // Similar ao Component Did Mount
  useEffect(() => {
    document.title = StringService.formatTitle(RouteKeys.TakeYourPicture.title);
    let livenessParceiro = '';

    AutoCapturaService.getParametroSistema({
      chave: ParamKeys.LIVENESS_OITI_HABILITADO,
    }).then((r) => {
      const {valor} = r;

      livenessParceiro = strPraBool(valor)
        ? ParceirosLiveness.OITI
        : ParceirosLiveness.CREDZ;

      // Configuração pra OITI
      if (livenessParceiro === ParceirosLiveness.OITI) {
        // Pega as credenciais do app settings
        AutoCapturaService.getParametroSistema({
          chave: ParamKeys.CREDENCIAL_LIVENESS,
        }).then((r) => {
          const {valor} = r;

          const {Valor} = JSON.parse(valor);

          // Monta o obj de config
          let settings = {
            cpf: props.cpf,
            nome: props.nome,
            nascimento: props.nascimento,
            user: Valor.USER,
            pass: Valor.PASS,
            fcvarUrlbase: Valor.URL,
            appKey: '',
          };

          AutoCapturaService.getAppKeyLiveness({
            cpf: settings.cpf,
            nascimento: settings.nascimento,
            nomeCompleto: settings.nome,
            sessao: 'string',
          })
            .then((key) => {
              // Setando as configurações da SDK
              settings.appKey = key;
              setLivenessSettings(settings);
              // Settando oq será renderizado.
              setState((prev) => ({
                ...prev,
                livenessParceiro: livenessParceiro,
              }));
            })
            .catch((err) => {
              // Setando a variavel pra trocar a tela, caso dê pau
              livenessParceiro = ParceirosLiveness.CREDZ;
              window.addEventListener('resize', ajustaAlturaDoVideo);
              setState((prev) => ({
                ...prev,
                livenessParceiro: livenessParceiro,
              }));
            });
        });
      } // end if

      if (livenessParceiro === ParceirosLiveness.CREDZ) {
        window.addEventListener('resize', ajustaAlturaDoVideo);
        setState((prev) => ({...prev, livenessParceiro: livenessParceiro}));
      }
    });

    // Similar ao Component Will Unmount
    return () => {
      if (
        livenessParceiro === ParceirosLiveness.CREDZ &&
        livenessParceiro !== ''
      ) {
        window.removeEventListener('resize', ajustaAlturaDoVideo);
      }

      // Pevenir vazamento de memoria.
      new AbortController().abort();
    };
  }, []);

  useEffect(() => {
    // Impedir a passagem
    if (
      resultLiveness.codID === 200.1 ||
      resultLiveness.codID === 200.2 ||
      resultLiveness.codID === 300.2
    ) {
      setFail(true);
    }

    // Tenta novamente.
    if (resultLiveness.codID === 300.1) {
      const prop = 'biometria';
      const value = resultLiveness.snap;

      props.updateDadosPessoais({prop, value});
      props.updateProps({prop: 'hideBtnNext', value: true});
      props.redirectToConfirmYourPicture();
    }

    // sucesso
    if (resultLiveness.codID === 1.1 || resultLiveness.codID === 1.2) {
      const prop = 'biometria';
      const value = resultLiveness.snap;

      props.updateDadosPessoais({prop, value});
      props.updateProps({prop: 'hideBtnNext', value: false});
      props.redirectToConfirmYourPicture();
    }

    if (resultLiveness.codID !== 0.0) {
      // Enviar esse item para a API
      const logLiveness = {
        IdProposal: 0,
        Cpf: livenessSettings.cpf,
        Cause: 'CERTIFACE',
        CodId: resultLiveness.codID,
        Protocol: resultLiveness.protocol,
        Validated: resultLiveness.valid,
        CreateDateTime: '', // Setar o now na API
        ReturnedJson: '',
      };

      const returnedJson = JSON.stringify({
        valid: resultLiveness.valid,
        codId: resultLiveness.codID,
        cause: 'CERTIFACE',
        protocol: resultLiveness.protocol,
      });

      AutoCapturaService.postLogLivenessResult({
        returnedJson,
        logLiveness,
        chave: props.chave,
      }).then(() => {});
    }
  }, [resultLiveness, fail]);

  useEffect(() => {
    if (state.livenessParceiro === ParceirosLiveness.OITI) {
      iniciarCamera().then(() => console.log('Camera Iniciada'));
    }
  }, [state]);

  // #region Codigo Antigo
  const pickHandle = (dataUri) => {
    const prop = 'biometria';
    const value = dataUri;

    props.updateDadosPessoais({prop, value});
    props.redirectToConfirmYourPicture();
  };

  const handleCameraError = (error) => {
    console.log(error);
    alert(
      'Infelizmente seu dispositivo não é compatível com a utilização da câmera.',
    );
    props.redirectToValidationAccessCode();
  };

  const ajustaAlturaDoVideo = () => {
    if (state.livenessParceiro === ParceirosLiveness.CREDZ) {
      const alturaCamera = document.getElementsByClassName(
        'react-html5-camera-photo',
      )[0].offsetHeight;
      let head = document.getElementsByClassName('head')[0];

      // aceita apenas 60% do tamanho
      // adiciona margem de seguranca de 30px
      head.style.height = (alturaCamera * 0.6 - 30).toString() + 'px';
      head.style.display = 'inherit';
      // setState({alturaCamera});
      setState((prev) => ({...state, alturaCamera}));

      if (
        firstLoad &&
        browser.name.toLowerCase().includes('safari') &&
        browser.os.toLowerCase().includes('mac')
      ) {
        mudarCameraEnvironment();
        firstLoad = false;
      }
    }
  };

  const mudarCameraUser = () => {
    const cameraAtiva = FACING_MODES.USER;
    const cameraEspelhada = true;
    setState((prev) => ({...state, cameraAtiva}));
    setState((prev) => ({...state, cameraEspelhada}));
  };

  const mudarCameraEnvironment = () => {
    const cameraAtiva = FACING_MODES.ENVIRONMENT;
    const cameraEspelhada = false;
    setState((prev) => ({...state, cameraAtiva}));
    setState((prev) => ({...state, cameraEspelhada}));
  };

  const alternarCamera = () => {
    if (state.cameraAtiva === FACING_MODES.USER) {
      mudarCameraEnvironment();
    } else {
      mudarCameraUser();
    }
  };
  // #endregion

  // #region liveness
  const componentRender = (isLivenessParceiro) => {
    switch (isLivenessParceiro) {
      case 'oiti':
        return (
          <LivenessComponent
            setResultLiveness={setResultLiveness}
            settings={livenessSettings}
          />
        );
      case 'credz':
        return (
          <div className="div-take-your-picture">
            <div className="container-titulo">
              <p className="info-h1">Tire sua foto.</p>
              <p className="info-h2">Fique bem em frente a</p>
              <p className="info-h2">câmera, igual foto de RG</p>
              <button
                className="button"
                id="botaoAlternar"
                onClick={alternarCamera}
              ></button>
            </div>

            <div className="container-video">
              <img src="/img/head.svg" alt="" className="head" />
              <Camera
                onCameraStart={() =>
                  setTimeout(() => ajustaAlturaDoVideo(), 500)
                }
                isDisplayStartCameraError={false}
                onCameraError={(error) => handleCameraError(error)}
                isImageMirror={state.cameraEspelhada}
                imageType={IMAGE_TYPES.JPG}
                onTakePhoto={(dataUri) => {
                  pickHandle(dataUri);
                  firstLoad = true;
                }}
                isSilentMode={true}
                idealFacingMode={state.cameraAtiva}
              />
            </div>
          </div>
        );
      default:
        return (
          <LivenessComponent
            setResultLiveness={setResultLiveness}
            settings={livenessSettings}
          />
        );
    }
  };

  if (fail) {
    return (
      <ScreenNotificationDefault
        title={<p>Análise Concluída</p>}
        contentCustom={
          <div className="div-pre-evaluation-completed-fail">
            <div>&nbsp;</div>
            <div className="info justify">
              <i>
                Agradecemos seu interesse pelo cartão, mas nesse momento não foi
                possível atendê-lo.
              </i>
            </div>
            <div>&nbsp;</div>
          </div>
        }
        contentButtons={
          <div className="div-data-contact">
            <Footer nextForm="frm" hideBtnBack={true} hideBtnNext={true} />
          </div>
        }
      />
    );
  }
  // #endregion

  return componentRender(state.livenessParceiro);
};

const mapStateToProps = ({customer}) => {
  const {chave} = customer;
  return {
    chave,
    ...customer.dadosPessoais,
  };
};

export default connect(mapStateToProps, {
  redirectToPhotoTime,
  redirectToConfirmYourPicture,
  updateProps,
  redirectToValidationAccessCode,
  updateDadosPessoais,
})(TakeYourPicture);
